export const purchaseModalTypes = {
  saleDossier: 'saleDossier',
  campaignDossier: 'campaignDossier',
  registrationDeliveryDossier: 'registrationDeliveryDossier'
}
